export default (data, filename) => {
  const a = window.document.createElement('a');
  a.href = data;
  a.download = filename;
  window.document.body.appendChild(a);
  a.click();
  window.document.body.removeChild(a);
};
